import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '../theme/theme.jsx';
import PayPage from '../pages/pay/PayPage.jsx';

/**
 * The whole application when the document is /pay: theme, router, page.
 *
 * Deliberately nothing else. The link token in this document is a card
 * payment credential, so the page gets none of the app's machinery:
 *   - no AuthProvider — the customer is not signed in here, and a signed-in
 *     driver's identity must not ride along;
 *   - no SessionProvider — it rewrites the URL and opens session streams;
 *   - no NotificationProvider / ToastProvider / NativeBridge;
 *   - and main.jsx installs neither the journey telemetry (which reports
 *     the page path and failed request paths) nor the default-axios
 *     interceptors for this document.
 */
export default function PayRoot() {
  return (
    <ThemeProvider>
      <Router>
        <Routes>
          <Route path="*" element={<main className="gc-flow-main"><PayPage /></main>} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}
